export default function Hero() {
  const stats = [
    { label: '每日更新', value: '200+', desc: '视频资源' },
    { label: '全网覆盖', value: '50+', desc: '内容来源' },
    { label: '高清画质', value: '1080P', desc: '流畅播放' },
  ];

  return (
    <section
      id="hero"
      className="relative w-full min-h-[500px] md:min-h-[600px] flex items-center pt-[64px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/30"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-primary-500/5 blur-3xl -translate-y-1/2 translate-x-1/3"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-accent-500/5 blur-3xl translate-y-1/2 -translate-x-1/3"></div>

      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-medium mb-4 md:mb-5">
              <i className="ri-fire-line text-sm"></i>
              今日热搜 · 实时更新
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight text-balance">
              51吃瓜视频
              <span className="block text-primary-500 text-xl md:text-3xl lg:text-4xl mt-1 md:mt-2">
                全网热门吃瓜视频聚集地
              </span>
            </h1>

            <p className="mt-2 md:mt-3 text-sm md:text-base text-accent-600 font-medium">
              每日更新 · 高清播放 · 免费观看 · 即点即看
            </p>

            <p className="mt-4 md:mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 text-balance">
              51吃瓜视频汇集全网最新最热的吃瓜视频资源，覆盖娱乐圈八卦、社会热点、网红爆料等多个领域。平台每日实时更新海量高清视频内容，支持在线点播与免费观看，让你随时随地掌握第一手吃瓜动态。无论你是资深瓜友还是偶尔吃瓜，这里都能即时满足你的吃瓜需求。
            </p>

            <div className="mt-5 md:mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-lg md:text-2xl font-black text-primary-500 whitespace-nowrap">
                    {s.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-0.5">
                    {s.label}
                  </div>
                  <div className="text-[10px] md:text-xs text-foreground-400">
                    {s.desc}
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-secondary-300 text-foreground-700 font-semibold text-sm md:text-base hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-bar-chart-line"></i>
                查看热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[520px] aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20vibrant%20digital%20entertainment%20platform%20interface%20with%20floating%20video%20cards%20and%20trending%20content%20thumbnails%2C%20warm%20coral%20and%20amber%20gradient%20background%2C%20abstract%20geometric%20shapes%2C%20minimalist%20Chinese%20web%20design%20aesthetic%2C%20soft%20glowing%20elements%2C%20editorial%20composition%2C%20high%20detail%20vibrant%20sophisticated%20visual&width=800&height=600&seq=hero-51chigua-2026&orientation=landscape"
                alt="51吃瓜视频平台主视觉 - 热门吃瓜视频在线观看"
                className="w-full h-full object-cover rounded-lg"
                onError={(e) => {
                  const el = e.currentTarget;
                  el.style.display = 'none';
                  if (el.parentElement) {
                    el.parentElement.classList.add(
                      'bg-gradient-to-br',
                      'from-primary-400/20',
                      'to-accent-400/20'
                    );
                    el.parentElement.classList.add('flex', 'items-center', 'justify-center');
                    const icon = document.createElement('i');
                    icon.className = 'ri-play-circle-line text-5xl md:text-7xl text-primary-300';
                    el.parentElement.appendChild(icon);
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}